import { ElementType } from 'components/element-viewer/index';
import { IconButton, Tooltip } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import React, { useState } from 'react';
import useBundleTranslation from 'i18n';
import AddToFavoritePopup from 'components/common/favorite/AddToFavoritePopup';
import { useEmbeddingContextVisible } from 'hooks/useEmbeddingContext';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import { dispatchCustomEvent } from 'tools/events';

const NamesToDisplay = 2;
export default function FavoriteButton({
    element,
    segmentValueId,
    onChange,
}: {
    element: ElementType;
    segmentValueId: number;
    onChange: () => void;
}) {
    const { t } = useBundleTranslation('app/favorites');
    const [isFormVisible, setIsFormVisible] = useState<boolean>(false);

    const customEvents = useSelector((state: RootState) => state.elementViewer.customEvents);
    const isApp = useSelector((state: RootState) => state.elementViewer.isApp);
    const hasIcon = useEmbeddingContextVisible('control_buttons.favorite');
    if (!hasIcon) {
        return null;
    }

    const n = element.inFavorites.length;
    const list =
        element.inFavorites
            .slice(0, NamesToDisplay)
            .map((f) => f.displayName)
            .join(', ') + (n > NamesToDisplay ? ', ...' : '');

    const toolTip = t('addFavorites', { count: n, list: list, entity: element.row.type });

    const handleSave = (elementId: number, segmentValueId: number, ids: Array<string>) => {
        setIsFormVisible(false);
        onChange();
    };

    const handleClose = () => {
        setIsFormVisible(false);
    };

    const onFavoriteClick = (event: any) => {
        if (isApp && customEvents && customEvents.favorite_click) {
            event.preventDefault();
            dispatchCustomEvent('mi-element-viewer', {
                action: 'favorite-click',
                payload: {
                    elementId: element.row.elementId,
                    segmentValueId: segmentValueId,
                },
            });
        } else {
            setIsFormVisible(true);
        }
    };

    return (
        <span data-test={'top-favorite-icon'}>
            <Tooltip title={toolTip}>
                <IconButton sx={{ p: '6px' }} onClick={onFavoriteClick}>
                    {n == 0 ? (
                        <IconMi icon="favorite" fontSize="16" />
                    ) : (
                        <IconMi sx={{ color: 'warning.main' }} icon="favorite-solid" fontSize="16" />
                    )}
                </IconButton>
            </Tooltip>

            {isFormVisible && (
                <AddToFavoritePopup
                    elementId={element.row.elementId}
                    segmentValueId={segmentValueId}
                    isOpen={isFormVisible}
                    onApply={handleSave}
                    onClose={handleClose}
                    elementName={element.row.name}
                />
            )}
        </span>
    );
}
